import React from 'react';

import { Text } from '~/domains/design-system/Text';

import { SkippedSectionComponent } from '../../../common/sections/SkippedSectionComponent/SkippedSectionComponent';
import { SectionSkeleton } from '../../../common/sections/Sections/SectionSkeleton';
import { useSectionQuery } from '../../hooks/useSectionQuery';
import { useSectionsNavigation } from '../../../common/context/hooks/useSectionsNavigation';
import { BaseSectionComponent } from '../BaseSectionComponent/BaseSectionComponent';
import { RestartSectionComponent } from '../../../common/sections/RestartSectionComponent/RestartSectionComponent';

import { SectionError } from './SectionError';

export function SectionSwitch({ sectionKey }: { sectionKey: string }) {
  const { sectionQuery, retryFn } = useSectionQuery(sectionKey);
  const { currentSection } = useSectionsNavigation();

  // Hiding not current sections to avoid unnecessary rendering
  if (!currentSection?.path.includes(sectionKey)) {
    return null;
  }

  if (sectionQuery.error) {
    return <SectionError error={sectionQuery.error} sectionKey={sectionKey} onRetry={retryFn} />;
  }

  if (sectionQuery.isLoading) {
    return <SectionSkeleton />;
  }

  if (!sectionQuery.isLoading && !sectionQuery.data) {
    return <RestartSectionComponent />;
  }

  switch (sectionQuery.type) {
    case 'BaseSection': {
      return <BaseSectionComponent section={sectionQuery.data} />;
    }
    case 'DynamicSection': {
      return <BaseSectionComponent section={sectionQuery.data} />;
    }
    case 'SkippedSection': {
      return <SkippedSectionComponent />;
    }

    case 'DynamicSections': {
      return (
        <>
          {sectionQuery.data.map((sectionKey2) => (
            <SectionSwitch key={sectionKey2} sectionKey={sectionKey2} />
          ))}
        </>
      );
    }
    default: {
      return <Text>Unknown section type</Text>;
    }
  }
}
